module.exports = __webpack_public_path__ + "images/543fb14ca1d9cde8b5ee9d5d291f382a-IMG_5598.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/living2/IMG_5598.jpg
// module id = ./src/assets/images/slides/living2/IMG_5598.jpg
// module chunks = 0